import React from "react";
import cover from "../IMG/Portfolio Cover.png";
import profile from "../IMG/Profile.JPEG";
import oralebadge from '../IMG/oracle badge.jpg'

import { Link } from "react-router-dom";

function Home_Intro() {
  return (
    <div className="max-w-5xl mx-auto  pt-6">
      <div className="bg-white rounded-md shadow-md overflow-hidden">

        {/* Cover Image */}
        <div className="w-full overflow-hidden">
          <img
            src={cover}
            alt="Cover"
            className="w-full h-auto"
          />
        </div>

        {/* Content Section */}
        <div className="px-6 md:px-10 pb-8  flex flex-col md:flex-row justify-between items-start md:items-center gap-6">

          {/* Left Section */}
          <div className="flex-1">
            <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-1">
              Akshat Srivastava
            </h1>

            <p className="text-sm md:text-base text-gray-700 mb-3 leading-relaxed max-w-2xl">
              Associate Software Engineer @ U2opia Mobile | Full-Stack Developer |
              Java, Spring Boot, React, AWS | 1+ YOE | Building Scalable
              Microservices & High-Performance UIs
            </p>

            <p className="text-sm text-gray-500 flex items-center mb-4">
              <svg
                className="w-4 h-4 mr-1.5"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                  clipRule="evenodd"
                />
              </svg>
              Gurugram, Haryana, India
            </p>

            <Link
              to="/Contact"
              className="inline-block px-6 py-2 bg-blue-600 text-white text-sm font-semibold rounded-full shadow-sm hover:bg-blue-700 transition"
            >
              Get In Touch
            </Link>
          </div>

          {/* Right Section (Badge) */}
          <div className="flex-shrink-0">
            <img
              src={oralebadge}
              alt="Oracle Badge"
              className="h-16 md:h-20 lg:h-24 w-auto"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home_Intro;
